import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const CustomerAuthContext = createContext(null);

export const CustomerAuthProvider = ({ children }) => {
    const [customer, setCustomer] = useState(null); // null=checking, false=unauth, obj=auth
    const [token, setToken] = useState(() => localStorage.getItem("Kanganya_customer_token") || "");

    useEffect(() => {
        if (!token) { setCustomer(false); return; }
        api.get("/auth/me", { headers: { Authorization: `Bearer ${token}` } })
            .then((r) => setCustomer(r.data))
            .catch(() => { setCustomer(false); setToken(""); localStorage.removeItem("Kanganya_customer_token"); });
    }, [token]);

    const requestOtp = async (name, email, phone) => {
        await api.post("/auth/signup/request-otp", { name, email, phone });
    };

    const verifyOtp = async (email, otp) => {
        const { data } = await api.post("/auth/signup/verify-otp", { email, otp });
        localStorage.setItem("Kanganya_customer_token", data.token);
        setToken(data.token);
        setCustomer(data.customer);
        return data.customer;
    };

    const requestLoginOtp = async (identifier) => {
        await api.post("/auth/login/request-otp", { identifier });
    };

    const verifyLoginOtp = async (identifier, otp) => {
        const { data } = await api.post("/auth/login/verify-otp", { identifier, otp });
        localStorage.setItem("Kanganya_customer_token", data.token);
        setToken(data.token);
        setCustomer(data.customer);
        return data.customer;
    };

    const logout = () => {
        localStorage.removeItem("Kanganya_customer_token");
        setToken("");
        setCustomer(false);
    };

    const authHeader = () => ({ Authorization: `Bearer ${token}` });

    return (
        <CustomerAuthContext.Provider value={{ customer, token, requestOtp, verifyOtp, requestLoginOtp, verifyLoginOtp, logout, authHeader }}>
            {children}
        </CustomerAuthContext.Provider>
    );
};

export const useCustomerAuth = () => {
    const ctx = useContext(CustomerAuthContext);
    if (!ctx) throw new Error("useCustomerAuth must be used within CustomerAuthProvider");
    return ctx;
};